<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="FinancesOverview")
    h1.title Rechnungen
    .sub-headline Hier sehen Sie alle Rechnungen.
    
    .button-wrapper.margin-top      
      b-button(type="is-light" icon-left="plus" @click="$router.push({name: 'CreateFinancesInvoices'})") Neue Rechnung erstellen

    .card.margin-top
      .main
        b-table(:data="financeInvoices"
                default-sort-direction="desc"
                default-sort="createdAt"
                hoverable)
          b-table-column(label='Empfänger' sortable, v-slot="props")
            div(v-if="props.row.customerId")
              a(@click="$router.push({ name: 'DataCustomerEdit', params: { id: props.row.customerId } })")
                b-icon(icon="account")
                | {{' ' + props.row.customer.lastName}} | 
              a(@click="$router.push('/booking/' + props.row.rentObjectBookingId)") {{'Buchung: #' + props.row.rentObjectBookingId}}
            a(@click="$router.push({ name: 'DataOwnerEdit', params: { id: props.row.ownerId } })" v-else)
              b-icon(icon="domain")
              | {{' ' + props.row.owner.fullName}}
          b-table-column(field='name' label='Name' sortable, v-slot="props")
            a(@click="openPDF('merged', props.row)") {{props.row.name}}
          b-table-column(field='attachmentName' label='Anhang' sortable, v-slot="props")
            a(v-if="props.row.attachmentName" @click="openPDF('attachment', props.row)") Anhang.pdf
          b-table-column(field='totalPrice' numeric label='Rechnungsbetrag' sortable, v-slot="props")
            | {{props.row.totalPrice/100 | toCurrency}}
          b-table-column(field='createdAt' label='erstellt am' sortable, v-slot="props")
            | {{formatDate(props.row.createdAt)}}
          b-table-column(label='Aktionen', v-slot="props")
            .button-wrapper
              //- b-button(type="is-primary" @click="$router.push({ name: 'DataCleanerEdit', params: { id: props.row.id } })") Bearbeiten
              b-button(type="is-danger" @click="deleteCleaner(props.row)") Löschen
</template>

<script>
import { DateTime } from 'luxon';

export default {
  data() {
    return {
    };
  },
  computed: {
    financeInvoices() {
      return this.$store.state.financeInvoices.all;
    },
  },
  methods: {
    async openPDF(dest, invoice) {
      let newFile;
      if (dest === 'attachment') {
        newFile = await this.$store.dispatch('financeInvoices/getAttachementPdf', {id: invoice.id});
      } else {
        newFile = await this.$store.dispatch('financeInvoices/getMergedPdf', {id: invoice.id});
      }
      const file = new Blob([newFile], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    },
    deleteCleaner(row) {
      this.$buefy.dialog.confirm({
        title: "Rechnung löschen",
        message: `Sind Sie sicher, dass Sie die Rechnung <b>${row.name}</b> löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: "Rechnung löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("financeInvoices/delete", { id: row.id });
            this.$buefy.toast.open("Rechnung gelöscht!");
          } catch (e) {
            this.$store.dispatch(
              "common/showError",
              "Rechnung konnte nicht gelöscht werden."
            );
          }
        }
      });
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd. LLL. yyyy hh:mm")
    },
  },
  mounted() {
    this.$store.dispatch("financeInvoices/findAll");
  }
};
</script>

<style lang="scss" scoped>
.icon-name {
  margin-left: $sm-space;
}
</style>